module.exports = __webpack_public_path__ + "img/default_background.149ea51c.png";